export enum GameTypeType {
  PRIMARY = "PRIMARY",
  CONFIGURED = "CONFIGURED",
}
